import { combineReducers } from 'redux';

import apiCalling from 'reducer/apiCalling';
import messageBox from 'reducer/messageBox';
import main from 'reducer/main';
import login from 'reducer/login';
import account from 'reducer/account';
import license from 'reducer/license';
import adapter from 'reducer/adapter/adapter';
import uniAdapter from 'reducer/adapter/uniAdapter';
import stats from 'reducer/stats';
import setting from 'reducer/setting';
import monitoring from 'reducer/monitoring';

const reducers = combineReducers({
	apiCalling,
	messageBox,
	main,
	login,
	account,
	license,
	adapter,
	uniAdapter,
	stats,
	setting,
	monitoring
});

export default reducers;
